// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"6a09d23c","412":"2a193901","490":"06a5a476","715":"9313d3ff"}[chunkId] + ".chunk.js";
};